import { controls, grouped } from "../controls";
const upload_pacs_otss = {
  label: "Upload PACS OTS",
  pageLabel: "Upload PACS OTS", starting: true, url: "autogen",
  formActions: { edit: { allow: true }, delete: { allow: false } },
  pageType: "history",
  formTabs:
  {
    allTabs: [
      { label: "File Details", uid: "general" },
      { label: "Upload", uid: "pacs_ots_datas" }
    ]
  },
  filter: [
    ...controls.magicDateLabel({ tab: "filter", label: "As On Date", target: "as_on_date" }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", dateType: "ontype" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
  ]
  , form: [
    ...controls.magicDateLabel({ tab: "general", label: "As On Date", target: "as_on_date", star: true }),
    ...controls.magicDate({ tab: "general", name: "as_on_date", dateType: "ontype", isRequired: true }),
    ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "pacs_ots_datas", label: "Serial", star: false }),
    ...controls.numberOnly({ tab: "pacs_ots_datas", placeHolder: "", name: "serial", isRequired: false, maxlength: 200 }),
    ...controls.displayText({ tab: "pacs_ots_datas", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "pacs_ots_datas", label: "Pacs Name", star: false }),
    ...controls.text({ tab: "pacs_ots_datas", placeHolder: "", name: "pacs_name", isRequired: false, maxlength: 20 }),
    ...controls.displayText({ tab: "pacs_ots_datas", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "pacs_ots_datas", label: "Count Defaulter Loanee 2019", star: false }),
    ...controls.numberOnly({ tab: "pacs_ots_datas", placeHolder: "", name: "count_defaulter_loanee_2019", isRequired: false, maxlength: 200 }),
    ...controls.displayText({ tab: "pacs_ots_datas", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "pacs_ots_datas", label: "Amount Defaulter Outstanding 2019" }),
    ...controls.floatOnly({ tab: "pacs_ots_datas", placeHolder: "", name: "amount_defaulter_outstanding_2019", maxlength: 18 }),
    ...controls.displayText({ tab: "pacs_ots_datas", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "pacs_ots_datas", label: "Count Recovery Overdue 2019", star: false }),
    ...controls.numberOnly({ tab: "pacs_ots_datas", placeHolder: "", name: "count_recovery_overdue_2019", isRequired: false, maxlength: 200 }),
    ...controls.displayText({ tab: "pacs_ots_datas", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "pacs_ots_datas", label: "Amount Recovery Overdue 2019" }),
    ...controls.floatOnly({ tab: "pacs_ots_datas", placeHolder: "", name: "amount_recovery_overdue_2019", maxlength: 18 }),
    ...controls.displayText({ tab: "pacs_ots_datas", label: "", width: "col-sm-2" }),

    ...controls.displayText({ tab: "pacs_ots_datas", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "pacs_ots_datas", width: "col-sm-2", label: "" }),
    ...controls.button({
      tab: "pacs_ots_datas",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "pacs_ots_datas",
        requiredField: ["serial", "pacs_name", "count_defaulter_loanee_2019", "amount_defaulter_outstanding_2019", "count_recovery_overdue_2019", "amount_recovery_overdue_2019",]
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "pacs_ots_datas",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "pacs_ots_datas",
        requiredField: ["serial", "pacs_name", "count_defaulter_loanee_2019", "amount_defaulter_outstanding_2019", "count_recovery_overdue_2019", "amount_recovery_overdue_2019",]
      }, width: "col-sm-2"
    }),


    ...controls.button({
      tab: "pacs_ots_datas",
      label: "SAMPLE",
      style: { padding: 0 },
      icon: "excel",
      onclick: {
        action: "downloadSample",
        tableNameField: "pacs_ots_datas",
        requiredField: ["serial", "pacs_name", "count_defaulter_loanee_2019", "amount_defaulter_outstanding_2019", "count_recovery_overdue_2019", "amount_recovery_overdue_2019",]
      }, width: "col-sm-2"
    }),

    ...controls.FileUpload({

      readFile: { targetTable: 'pacs_ots_datas', type: 'csv', columns: ["serial", "pacs_name", "count_defaulter_loanee_2019", "amount_defaulter_outstanding_2019", "count_recovery_overdue_2019", "amount_recovery_overdue_2019",] },
      label: "Fileupload",
      name: "bulk_file_upload",
      placeholder: {
        type: "text",
        value: "Upload Bulk files"
      },
      tab: "pacs_ots_datas",
      width: "col-sm-2"
    }),


    {
      tab: "pacs_ots_datas",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Serial", field: "serial" },
        { label: "Pacs Name", field: "pacs_name" },
        { label: "Count Defaulter Loanee 2019", field: "count_defaulter_loanee_2019" },
        { label: "Amount Defaulter Outstanding 2019", field: "amount_defaulter_outstanding_2019" },
        { label: "Count Recovery Overdue 2019", field: "count_recovery_overdue_2019" },
        { label: "Amount Recovery Overdue 2019", field: "amount_recovery_overdue_2019" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "pacs_ots_datas"
    },
  ]
  , history: {
    perPage: 10,
    reportHeader: "Upload Pacs Otss",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "As On Date", accessor: "as_on_date", type: 'date' },
    ]
  }
};
export default upload_pacs_otss;